import React, { useEffect, useRef } from 'react';
import ChatFrameworkInputBoxSendIcon from 'ui/ds/icons/ChatFrameworkInputBoxSendIcon';
import { AskMeAnythingProps } from '../../types';
import { useAppContext } from '../../context/AppContext';

const AskMeAnything = ({
  handleSubmit,
  query,
  handleInputChange,
  isSubmitEnabled,
  isStreaming,
}: AskMeAnythingProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const { isWebView } = useAppContext();

  //textarea gets automatically focused after the response. Only for web.
  useEffect(() => {
    if (!isStreaming && textareaRef.current && !isWebView) {
      textareaRef.current.focus();
    }
  }, [isStreaming, isWebView]);

  //shift+enter will not work
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const textarea = e.currentTarget;

    if (e.key === 'Enter' && e.shiftKey) {
      e.preventDefault();
      const { selectionStart, selectionEnd } = textarea;
      const newValue =
        query.substring(0, selectionStart) +
        '\n' +
        query.substring(selectionEnd);
      handleInputChange({
        target: { value: newValue } as HTMLTextAreaElement,
        currentTarget: textarea,
      } as React.ChangeEvent<HTMLTextAreaElement>);

      textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
    } else if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit(e as unknown as React.FormEvent<HTMLFormElement>);
    }
  };

  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    handleInputChange(e);
  };

  return (
    <div className={`w-full bg-transparent`}>
      <div className="bg-white flex w-full flex-col items-center justify-center md:w-full">
        <div className="w-[100%] max-w-4xl md:w-full">
          <form onSubmit={handleSubmit} className="w-full bg-white">
            <div
              className={`flex w-full flex-1 bg-white pt-5 p-3 h-[73px]`}
              style={{
                borderTop: '1px solid #E1E5EB',
                borderTopLeftRadius: '1rem',
                WebkitBorderTopRightRadius: '1rem',
              }}
            >
              <textarea
                ref={textareaRef}
                className="w-full outline-none pr-[25px] pl-[16px] bg-white text-area"
                style={{ resize: 'none' }}
                value={query}
                onChange={handleTextareaChange}
                onKeyDown={handleKeyDown}
                placeholder="Ask your question here"
                disabled={isStreaming}
              />
              <button
                aria-label="send"
                className="w-auto min-w-[0px] pb-[16px]"
                type="submit"
                disabled={!isSubmitEnabled}
              >
                <ChatFrameworkInputBoxSendIcon
                  state={isSubmitEnabled ? 'active' : 'inactive'}
                />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AskMeAnything;
